var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding":"20px 0 30px","height":"500px"}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":require("@/assets/img/organization.png"),"alt":"组织架构"}})])
}]

export { render, staticRenderFns }